export default "__VITE_PUBLIC_ASSET__4439c674__"